module.exports = __webpack_public_path__ + "static/media/article1_slide2.1963061e.jpg";